var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33463 3.20833C9.33463 4.98024 7.89821 6.41666 6.1263 6.41666C4.35438 6.41666 2.91797 4.98024 2.91797 3.20833C2.91797 1.43642 4.35438 0 6.1263 0C7.89821 0 9.33463 1.43642 9.33463 3.20833ZM0.45 14C0.201472 14 0 13.7985 0 13.55C0 11.8699 0 11.0298 0.296705 10.3881C0.557691 9.82357 0.974139 9.36461 1.48637 9.07699C2.06868 8.75002 2.83097 8.75002 4.35555 8.75002H7.89443C9.41901 8.75002 10.1813 8.75002 10.7636 9.07699C11.2758 9.36461 11.6923 9.82357 11.9533 10.3881C12.25 11.0298 12.25 11.8699 12.25 13.55V13.55C12.25 13.7985 12.0485 14 11.8 14H0.45Z",
    fill: "url(#paint0_linear_2801_1148)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2801_1148",
    x1: -1.57893e-7,
    y1: -0.882812,
    x2: 15.7854,
    y2: 7.74781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#810BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF45FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.45d8a2189b309f1bff8d0eeca3694192.svg";
export { ForwardRef as ReactComponent };